// extracted by mini-css-extract-plugin
export var imageAndTitles = "styles-module--imageAndTitles--67a64";
export var position = "styles-module--position--38251";
export var textContent = "styles-module--textContent--a6c93";